import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    margin: '10rem auto 0 !important',
  },
  grid: {
    height: '100%',
    backgroundColor: '#fff',
    justifyContent: 'center !important',
    marginTop: '3rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.15) !important',
    marginRight: '0 !important',
    marginLeft: '0 !important',
    padding: '1.25rem !important',
  },
  centerColumn: {
    justifyContent: 'center',
  },
  column: {
    width: '32% !important',
  },
  columnWide: {
    width: '100% !important',
  },
  header: {
    color: `${theme.violet} !important`,
    fontSize: '1.5rem !important',
    fontWeight: '300 !important',
    textAlign: 'left !important',
  },
  cardContainer: {
    backgroundColor: '#fff !important',
    borderRadius: '.375rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '.625rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',
    position: 'relative !important',
  },
  formGrid: {
    margin: '0 !important',
  },
  formRow: {
    padding: '.5rem 0 !important',
  },
  fieldGroup: {
    width: '100%',
    marginTop: '.65rem !important',
    justifyContent: 'center !important',
  },
  label: {
    color: '#4a4a4a !important',
    fontSize: '1.1rem !important',
    marginRight: '1rem !important',
  },
  cardHeader: {
    color: 'black',
  },
  clientWrapper: {
    display: 'flex !important',
    flexDirection: 'row !important',
    justifyContent: 'flex-start !important',
  },

  spacer: {
    paddingRight: '.75rem !important',
  },
  editLink: {
    marginTop: '1.25rem',
    fontWeight: '500 !important',
  },
  smallDropDown: {
    width: '31% !important',
  },
  button: {
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '1.5em !important',
    color: '#fff !important',
    marginTop: '1rem !important',
    height: '3.125rem',
    fontWeight: 'bold !important',
    width: '100%',
    outline: 0,
    border: 'none !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  buttonSecondary: {
    marginRight: '.45rem !important',
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    height: '3.125rem',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  mediumBtn: {
    width: '48% !important',
  },
});

export default styles;
